interface Partner {
  name: string;
  logo: string;
}

export default function PartnersSection({ partners }: { partners: Partner[] }) {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            合作伙伴
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            与全球顶级品牌合作，共同推动电竞产业发展
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="flex items-center justify-center p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-10 w-auto object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}